import {
  lang_default
} from "./chunk-3XF77UUS.mjs";
import {
  insertText,
  removeCharOfString
} from "./chunk-D3GX5FQV.mjs";

// src/lang/index.ts
var defaultLang = lang_default["en"];
var t = (key, status, ...props) => {
  var _a;
  let text = defaultLang[key][status];
  var regex = new RegExp("\\?\\?", "g");
  let i = 0;
  while ((text == null ? void 0 : text.search(regex)) !== -1) {
    if (!props[i]) {
      break;
    }
    const index = text == null ? void 0 : text.search(regex);
    text = removeCharOfString(text, index, index + 1);
    text = insertText(text, index, ((_a = props[i]) == null ? void 0 : _a.toString()) || "");
    i++;
  }
  return text;
};
var setLocale = (locale) => {
  defaultLang = lang_default[locale];
  return { t };
};
var lang_default2 = setLocale;

export {
  lang_default2 as lang_default
};
